import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';

import error from "../../assets/images/error-img.png";

const Unauthorized = () => {
    return (
        <React.Fragment>
            <div className="my-5 pt-5">
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div className="text-center mb-4">
                                <h1 className="display-1 fw-semibold">4<span className="text-danger mx-2">0</span>3</h1>
                                <h4 className="text-uppercase text-danger fw-bold">Access Denied / Not Authorized</h4>
                                <p className="text-muted mt-2 fs-5">
                                    You do not have permission to view or access this project.
                                </p>
                                <div className="mt-4 text-center">
                                    <Link className="btn btn-primary me-2" to="/dashboard">
                                        Back to Dashboard
                                    </Link>
                                    <Link className="btn btn-secondary" to="/project">
                                        Back to Projects
                                    </Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <div className="row justify-content-center">
                        <div className="col-md-8 col-xl-6 text-center">
                            <div>
                                <img src={error} alt="Access Denied" className="img-fluid" style={{ maxHeight: "250px" }} />
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Unauthorized;
